const Types = {
  CARDS__GET_CARD_LIST: 'CARDS__GET_CARD_LIST',
  CARDS__ADD_CARD: 'CARDS__ADD_CARD',
  CARDS__DELETE_CARD: 'CARDS__DELETE_CARD',
};

export default Types;
